import React from 'react';
import { Card as KendoCard } from '@progress/kendo-react-layout';

/**
 * Card component wrapping KendoReact Card with all supported props.
 * 
 * @see {@link https://www.telerik.com/kendo-react-ui/components/layout/card | KendoReact Card Documentation}
 * 
 * @param {object} props
 * @param {React.ReactNode} [props.children] - Card children elements.
 * @param {string} [props.className] - Additional classes for the Card.
 * @param {string} [props.dir] - Direction of the Card ('ltr' or 'rtl').
 * @param {string} [props.orientation] - Orientation of the Card ('horizontal' | 'vertical').
 * @param {React.CSSProperties} [props.style] - Additional CSS styles.
 * @param {string} [props.type] - Type of the Card ('default' | 'primary' | 'info' | 'success' | 'warning' | 'error').
 * @param {boolean} [props.disabled] - Whether the Card appears disabled.
 * @returns {JSX.Element}
 */
export const Card = ({
  children,
  className = '',
  dir,
  orientation,
  style = {},
  type,
  disabled = false
}) => (
  <KendoCard
    className={`${className} ${disabled ? 'card-disabled' : ''}`}
    dir={dir}
    orientation={orientation}
    style={style}
    type={type}
  >
    {children}
  </KendoCard>
);